// FE/src/pages/admin/BankAccountsAdministrationPage.jsx
import { useEffect } from "react";
import { Navigate } from "react-router";
import BankAccountTable from "components/tables/BankAccountTable.jsx";
import { Box, Typography } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import { useUser } from "@accredo/fe-shared/hooks/user.js";

export default function BankAccountsAdministrationPage() {
  const { user } = useUser();
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Bankverbindungen", path: "/admin/bankaccounts" },
    ]);
  }, [setBreadcrumbs]);

  // Seite ist nur für sysadmin zugänglich (Backend beschränkt die
  // zugehörigen Endpunkte ebenfalls auf diese Rolle).
  if (!user?.role_names?.includes("sysadmin")) {
    return <Navigate to="/home" replace />;
  }

  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Bankverbindungen
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Hier können Sie Bankaccounts verwalten.
        </Typography>
      </Box>
      <BankAccountTable scope="admin" />
    </>
  );
}
